export default __webpack_public_path__ + "static/media/gallery_16.af93d2fe.jpg";